module.exports = __webpack_public_path__ + "static/media/vpn@3x.0ba58f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/vpn@3x.png
// module id = 356
// module chunks = 0